/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 17. 動画の再生 */
export const template17 = {
  title: t.to('音声再生', 'title17'),
  desc: t.to(
    `ファイル管理画面で音楽ファイルをアップロードしてブロックとして追加することで、VRやARに音楽や効果音を組み込むことができます。自動再生を選択している場合は音声の再生を許可する必要があります`,
    'desc17'
  ),
  img: '../public/template/17.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="90" y="130">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="video_elem_v2">
        <field name="type">a-video</field>
        <field name="play">auto</field>
        <field name="src">/public/movie/Sample1.mp4</field>
        <field name="position-x">2</field>
        <field name="position-y">1.7</field>
        <field name="position-z">0</field>
        <value name="ATTR">
          <block type="scale_v2">
            <field name="scale-x">2</field>
            <field name="scale-y">1</field>
            <field name="scale-z">1</field>
          </block>
        </value>
        <next>
          <block type="cube_v2">
            <field name="id">block</field>
            <field name="position-x">-2</field>
            <field name="position-y">0</field>
            <field name="position-z">0</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#192fba</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="sound_att_v2">
                <field name="src">/public/sound/Sorrow.mp3</field>
                <field name="volume">1.0</field>
                <field name="loop">true</field>
                <field name="autoplay">auto</field>
              </block>
            </value>
            <next>
              <block type="environment_v2">
                <field name="environment">preset:forest</field>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>
`,
};
